export default "__VITE_ASSET__k9o$zsrn__"